import React from 'react';
import { useRouteError, Link } from 'react-router-dom';

const ErrorPage = () => {
    const error = useRouteError();
    console.error(error);

    return (
        <div className="error-page">
            <div className="error-container">
                <h1>Oops!</h1>
                <p className="error-subtitle">Sorry, an unexpected error has occurred.</p>
                <div className="error-details">
                    <p>
                        <i>{error?.statusText || error?.message || "Unknown Error"}</i>
                    </p>
                    {error?.status === 404 && (
                        <p className="error-explanation">The page you are looking for does not exist or has been moved.</p>
                    )}
                </div>
                <Link to="/" className="btn btn-primary">
                    Go Back Home
                </Link>
            </div>

            <style>{`
                .error-page {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 100vh;
                    width: 100vw;
                    background-color: var(--background);
                    background-image: radial-gradient(circle at 10% 20%, rgba(214, 168, 168, 0.1) 0%, transparent 20%),
                        radial-gradient(circle at 90% 80%, rgba(212, 140, 149, 0.05) 0%, transparent 20%);
                    padding: 20px;
                    position: fixed; /* Ensure it covers everything */
                    top: 0;
                    left: 0;
                    z-index: 9999;
                }

                .error-container {
                    background: var(--glass-bg);
                    backdrop-filter: var(--glass-blur);
                    border: var(--glass-border);
                    border-radius: var(--radius-lg);
                    padding: 40px;
                    text-align: center;
                    box-shadow: var(--shadow-lg);
                    max-width: 500px;
                    width: 100%;
                }

                .error-page h1 {
                    font-family: var(--font-heading);
                    font-size: 4rem;
                    color: var(--primary);
                    margin-bottom: 20px;
                    line-height: 1;
                }

                .error-subtitle {
                    font-size: 1.25rem;
                    color: var(--text-main);
                    margin-bottom: 20px;
                    font-weight: 600;
                }

                .error-details {
                    margin-bottom: 30px;
                    color: var(--text-light);
                    font-size: 1rem;
                }
                
                .error-explanation {
                    margin-top: 10px;
                    font-size: 0.95rem;
                }

                .error-page .btn-primary {
                    display: inline-block;
                    text-decoration: none;
                    background-color: var(--primary);
                    color: var(--white);
                    padding: 12px 30px;
                    border-radius: var(--radius-full);
                    font-weight: 600;
                    transition: all 0.3s ease;
                }
                
                .error-page .btn-primary:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(181, 131, 131, 0.4);
                }
            `}</style>
        </div>
    );
};

export default ErrorPage;
